"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var combinePlatformUrl_1 = __importDefault(require("./combinePlatformUrl"));
var courseBuilderApi_1 = require("../mock/courseBuilderApi");
var CourseBuilderAPIs = {
    publishSystemCourse: function (uuid) {
        return rest_1.default.post({
            mockFunc: courseBuilderApi_1.publishSystemCourse,
            url: (0, combinePlatformUrl_1.default)("/api/v2/courses/".concat(uuid, "/publish/")),
        });
    },
    createSystemCourse: function (systemCourse) {
        return rest_1.default.post({
            mockFunc: courseBuilderApi_1.createSystemCourse,
            url: (0, combinePlatformUrl_1.default)('/api/v2/courses/'),
            body: systemCourse,
        });
    },
    editSystemCourse: function (systemCourse, uuid) {
        return rest_1.default.put({
            mockFunc: courseBuilderApi_1.editSystemCourse,
            url: (0, combinePlatformUrl_1.default)("/api/v2/courses/".concat(uuid, "/")),
            body: systemCourse,
        });
    },
    getSystemCourses: function (published) {
        return rest_1.default.get({
            mockFunc: courseBuilderApi_1.getSystemCourses,
            url: (0, combinePlatformUrl_1.default)("/api/v2/courses?status=".concat(published ? 'published' : 'unpublished')),
        });
    },
    publishSingleLesson: function (courseUuid, lessonUuid) {
        return rest_1.default.post({
            mockFunc: courseBuilderApi_1.getSystemCourses,
            url: (0, combinePlatformUrl_1.default)("/api/v2/courses/".concat(courseUuid, "/lesson/").concat(lessonUuid)),
        });
    },
};
exports.default = CourseBuilderAPIs;
